import { Theme, createStyles } from '@material-ui/core';
const styles = (theme: Theme) =>
  createStyles({
    viewHistoryDropdown: {
      position: 'relative',
      '& .viewHistoryButton': {
        border: '1px solid #E6E6E6',
        borderRadius: '4px',
        backgroundColor: '#ffffff',
        fontSize: '14px',
        fontWeight: 600,
        color: '#1D7DEA',
        height: '48px',
        minWidth: '150px',
        marginLeft: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '& img': {
          marginLeft: '11px',
        }
      },
      '& .viewHistoryDropdownListBox': {
        border: '1px solid #E6E6E6',
        borderRadius: '6px',
        boxShadow: '0 5px 8px 0 rgba(0, 0, 0, 0.2)',
        position: 'absolute',
        top: '66px',
        right: '0',
        margin: '0',
        backgroundColor: '#ffffff',
        zIndex: 999,
        width: '472px',
        overflowX: 'visible',
        '&.hide': {
          display: 'none',
        },
        '& .arrowIcon': {
          top: '-12.5px',
          right: '65px',
          width: '0',
          height: '0',
          position: 'absolute',
          borderLeft: '12.5px solid transparent',
          borderRight: '12.5px solid transparent',
          borderBottom: '25px solid #E6E6E6',
          '&::before': {
            content: "''",
            top: '2px',
            left: '-50%',
            width: '0',
            position: 'absolute',
            transform: 'translateX(-50%)',
            borderLeft: '11.5px solid transparent',
            borderRight: '11.5px solid transparent',
            borderBottom: '24px solid #fff',
          }
        },
      },
      '& .viewHistoryDropdownList': {
        borderRadius: '5px',
        padding: '15px 0',
        maxHeight: '262px',
        overflowY: 'auto',
        backgroundColor: '#ffffff',
        margin: '0',
        zIndex: 1,
        position: 'relative',
        '&::-webkit-scrollbar': {
          width: '4px',
          borderRadius: '20px',
          background: '#e3e3e3',
        },
        '&::-webkit-scrollbar-thumb': {
          outline: 'none',
          background: '#9c9c9c',
          borderRadius: '10px',
        },
        '& li': {
          listStyle: 'none',
          padding: '10px 15px 20px',
          position: 'relative',
          '&::before': {
            content: "''",
            position: 'absolute',
            top: 0,
            left: '111px',
            borderRight: '1px dashed rgba(153, 153, 153, 0.6)',
            width: '1px',
            height: '100%',
            zIndex: 0,
          },
          '& .historyContent': {
            display: 'flex',
            alignItems: 'center',
            paddingBottom: '5px',
          },
          '& .dateTimeColumn': {
            width: '80px',
            position: 'relative',
          },
          '& .timeLineCircle': {
            width: '16px',
            minWidth: '16px',
            height: '16px',
            borderRadius: '50%',
            backgroundColor: '#1D7DEA',
            margin: '0 20px 0 10px',
            position: 'relative',
          },
          '& .dateTimeColumn p': {
            fontSize: '12px',
            fontWeight: 400,
            color: '#666666',
            margin: 0,
            lineHeight: '150%',
            textAlign: 'right',
            '& .timeCol': {
              color: '#999999',
              display: 'block',
            }
          },
          '& .contentColumn': {
            width: 'calc(100% - 126px)',
            '& p': {
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '114%',
              color: '#666666',
              margin: 0,
              wordBreak: 'break-word',
              whiteSpace: 'initial',
            }
          },
          '& .viewDetailsRow': {
            paddingLeft: '126px',
            '& .viewDetailsBtn': {
              fontSize: '12px',
              fontWeight: 600,
              color: '#1D7DEA',
              cursor: 'pointer',
              display: 'block',
              lineHeight: '116%',
            }
          },
        }
      }
    },
    
    root: {
      minWidth: 275,
    },
    verticleLine: {
      border: "0.5px solid #333333",
      margin: "0 12px",
      backgroundColor: "#333",
    },
    expansionRoot: {
      flex: "grow",
    },
    disabledCTA: {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
    chipStyle:{
      // color: "#F4B40D",
      minWidth: 52,
      // border: "1px solid #F4B40D",
      margin: "0 10px 6px",
      height: 20,
      backgroundColor: "#fff",
      fontSize: 12,
      '& span':{
        textTransform: 'capitalize',
      },
    },
    backArrowHeading:{
      fontSize: 24,
      lineHeight: '33px',
      color: '#333'
    },
    backArrow:{
      '& img':{
        verticalAlign: "sub",
        marginRight:10,
        marginLeft:13,
      },
      '& svg':{
        marginRight: 10,
        width: 20,
      }
    },
    bullet: {
      display: "inline-block",
      margin: "0 2px",
      transform: "scale(0.8)",
    },
    tabContainer: {
      position:'relative',
      padding: "12px 0",
      //   borderBottom: "0.5px solid #bcbcbc",
      paddingBottom: 6,
      // margin: "0px 12px",
      height: "73px",
      "&>div:nth-of-type(1)": {
        "& button": {
          border: "1px solid #999999",
          padding: 0,
          fontSize: 16,
          backgroundColor: '#fff',
          color: '#666',
          '&:nth-of-type(1)':{
            borderTopLeftRadius:4, 
            borderBottomLeftRadius:4, 
          },
          '&:last-child':{
            borderTopRightRadius:4, 
            borderBottomRightRadius:4, 
          }                
        },
      },
      '& .tabsSec': {
        overflow: 'inherit',
      },
      '& .tabsSec>div>div': {
        overflow: 'inherit',
      },
    },
    tabPanel: {
      marginTop: 25,
      marginBottom: 12,
      // background: 'rgb(255 255 0)',
      // position: 'absolute',
      right: 0,
      left: 0,
      top: "100%",
      "& .subPanel": {
        color: "rgb(153 153 153)",
        padding: "0",
        fontSize: 16,
        fontWeight: 600,
        cursor: "pointer",
        "& > *": {
          cursor: "pointer",
        },
      },
      "& > *": {
        marginBottom: 10,
      },
      "& .activeTab": {
        color: "#1D7DEA",
      },
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    cursorPointer: {
      cursor: "pointer",
    },
    link: {
      fontSize: "1.125rem",
      "&:hover": {
        color: "#333",
        fontWeight: 600,
      },
    },
    primaryBtn: {
      background: "#1D7DEA",
      borderRadius: 4,
      maxWidth: 186,
      minHeight: 44,
    },
    fontWeight600: {
      fontWeight: 600,
    },
    blackColor: {
      color: "#333",
    },
    darkGrey: {
      color: "#999",
    },
    dialogTitle: {
      fontWeight: 600,
      fontSize: 24,
      color: "#333",
    },
    labelText: {
      "& :nth-child(2)": {
        fontStyle: "normal",
        fontWeight: "normal",
        fontSize: 16,
        lineHeight: "19px",
        color: "#333333",
        marginTop: 2,
      },
    },
    HeadingText: {
      fontSize: 18,
      color: "#333",
      marginBottom: 10,
    },
    paddingLeft56: {
      paddingLeft: 56,
    },
    linearProgressStyle: {
      minWidth: "85px",
      margin: "0 5px",
      display: "flex",
      alignItems: "center",
      "&>div:nth-of-type(1)": {
        display: "flex",
        minWidth: "85px",
        margin: "0 5px",
        borderRadius: 4,
      },
    },
    tabArea: {
      backgroundColor: '#FFFFFF',
      border: "1px solid #E4E4E4",
      // paddingBottom: 100,
      marginTop: 20,
    },
    testSeriesContainer: {
      backgroundColor: "#F1F1F1",
      border: "1px solid #E4E4E4",
      paddingBottom: 0,
      marginTop: 20,
      '& $.DialogHeader':{
        paddingLeft: 0,
      }
    },
    active_tab: {
      fontSize: 16,
      color: "#fff!important",
      backgroundColor: "#1d7dea!important",
      border: "none !important",
      fontWeight: 600,
    },
    indicatorColorStyle: {
      display: "none",
    },
    tabAreaContainer:{
      paddingBottom: 50,
    },
    liveColor:{
      color:'#67BF02 !important',
      borderColor:'#67BF02 !important'
    },
    draftColor:{
      color:'#F4B40D !important',
      borderColor:'#F4B40D !important'
    },
    publishColor:{
      color:'#1d7dea !important',
      borderColor:'#1d7dea !important'
    },
    pastColor:{
      color:'#D9505D !important',
      borderColor:'#D9505D !important'
    },
    addVersionBtn:{
      color: '#666666',
      width: '130px',
      border: "1px solid #DDDDDD",
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
      padding: 0,
    },
    mLeft5: {
      marginLeft: 5,
    },
    planSummary:{
      position:'absolute',
      right:9,
      top:7,
      border: '1px solid #1d7dea',
      borderRadius: '4px',
      background: '#ffffff',
      fontSize: '14px',
      fontWeight: 600,
      color: '#1d7dea',
      height: '48px',
      minWidth: '150px',
      marginLeft: '20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    headingText: {
      fontSize: 24,
      fontWeight: 600,
      color: '#333',
      textAlign: 'center',
      margin: 0,
    },
    paraText: {
      fontSize: 16,
      fontWeight: 400,
      color: '#333',
      marginBottom: 20,
      textAlign: 'center',
    },
    selectImg: {
      marginBottom: 10,
      textAlign: 'center',
    },
    selectViewContainer: {
      position: 'relative'
    },
    close: {
      position: 'absolute',
      right: '-10px',
      top: '-25px',
      cursor: 'pointer',
    },
    viewList: {
      listStyle: 'none',
      padding: 0,
      margin: '0 0 40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
      '& li': {
        borderRadius: 32,
        height: 36,
        padding: '9px 20px',
        fontSize: 14,
        color: '#1D7DEA',
        fontWeight: 400,
        border: 'solid 1px #1d7dea',
        cursor: 'pointer',
        textAlign: 'center',
      },
      '& li.active': {
        backgroundColor: '#1D7DEA',
        color: '#fff'
      }
    }
  });

export { styles };